'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var parcelAddStep2DetailsFormComponent = exports.parcelAddStep2DetailsFormComponent = {
    template: require('./parcel-add-step2-details-form.html'),
    bindings: {
        receiver: '<',
        delivery: '<',
        submitStep2: '&',
        cancel: '&'
    },
    controllerAs: 'vm',
    controller: ["gettextCatalog", "parcelService", function parcelAddStep2DetailsFormController(gettextCatalog, parcelService) {
        'ngInject';

        var vm = this;

        vm.$onInit = init;
        vm.submitStep2Form = submitStep2Form;
        vm.onCancel = onCancel;
        vm.addOrderline = addOrderline;
        vm.deleteOrderline = deleteOrderline;
        vm.onPackageTypeSelection = onPackageTypeSelection;

        vm.packageTypes = parcelService.podPackageTypes;

        vm.orderlines;
        vm.remark;
        vm.qty1;
        vm.qty2;
        vm.qty3;
        vm.qtyHcp;

        function init() {
            initForm();
        }

        function initForm() {
            if (vm.delivery) {
                vm.orderlines = vm.delivery.orderlines;
                vm.remark = vm.delivery.remark;
            } else {
                resetForm();
            }
        }

        function resetForm() {
            vm.orderlines = [];
            vm.remark = null;
            vm.addOrderline();
        }

        function addOrderline() {
            vm.orderlines.push({
                packageType: null,
                packageTypeCode: null,
                hasInsurance: false,
                packageValue: null,
                insurancePriceDescription: null,
                packageTypeError: null
            });
        }

        function onPackageTypeSelection(index) {
            var ol = vm.orderlines[index];
            var insurancePrice = vm.packageTypes.find(function (pt) {
                return pt.code === ol.packageTypeCode;
            }).insurancePrice;
            ol.insurancePriceDescription = gettextCatalog.getString('parcel.insuranceDescription', { insurancePrice: insurancePrice });
        }

        function deleteOrderline(index) {
            vm.orderlines.splice(index, 1);
        }

        function submitStep2Form() {
            if (vm.formReference.$valid) {
                vm.orderlines.forEach(function (element) {
                    element.packageTypeError = !element.packageTypeCode ? gettextCatalog.getString('parcel.pleaseSelectPackageType') : null;
                });
                if (!vm.orderlines.find(function (x) {
                    return x.packageTypeError;
                })) {
                    var deliveryDetails = {
                        remark: vm.remark,
                        orderlines: vm.orderlines.map(function (orderLine) {
                            orderLine.packageType = vm.packageTypes.find(function (pt) {
                                return pt.code === orderLine.packageTypeCode;
                            });
                            return orderLine;
                        })
                    };
                    vm.submitStep2({ $event: deliveryDetails });
                }
            }
        }
        function onCancel() {
            vm.cancel();
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-add-step2-details-form.js
// module id = 872
// module chunks = 0